import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/layout'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const Wrapper = styled.div`
  display: grid;
`

export const ButtonUpload = styled.button.attrs((props) => composeTheme(props))`
  align-items: center;
  border-radius: 0.4rem;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: ${fonts.inter};
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  height: 4rem;
  justify-content: center;
  letter-spacing: 0em;
  margin: 0;
  overflow: visible;
  padding: 0.4rem 1.6rem;
  text-align: center;
  text-transform: none;
  width: 100%;

  span {
    color: ${colors.feedbackColorNegativePure};
  }

  &.enabled {
    background: #f1f1f1;

    &:hover {
      background: ${colors.neutralColorLowLight};
    }
  }

  &.complete {
    background: ${(props) => props.theme.brandColors.primaryPure};
    color: ${colors.neutralColorHighPure};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${colors.neutralColorHighMedium};
    color: ${colors.neutralColorLowMedium};
    pointer-events: none;
  }

  &:focus {
    outline: none;
  }

  &.negative {
    background-color: ${colors.feedbackColorNegativeLight};
    color: ${colors.feedbackColorNegativePure};
  }

  &.fill {
    justify-content: space-between;
  }

  .MuiSvgIcon-root {
    width: 2.5rem;
    margin-right: 1.4rem;
  }
`
export const Label = styled.p`
  position: relative;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  margin: ${layout.margin.spacingNone};
`

export const Hint = styled.p.attrs((props) => composeTheme(props))`
  align-items: left;
  color: #8c8c8c;
  font-family: ${fonts.inter};
  font-size: 1.4rem;
  font-style: normal;
  font-weight: normal;
  line-height: 150%;
  margin-top: 0.8rem;

  &.negative {
    color: ${(props) => props.theme.hint.negativeColor};
  }
`
export const IconContainer = styled.div`
  color: ${colors.neutralColorHighPure};
  cursor: pointer;
  margin-left: 1.6rem;
`
export const ButtonContainer = styled.div`
  align-items: center;
  width: 100%;
  display: flex;
`

export const ButtonDownload = styled.a`
  &:link {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
  }

  &:visited {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  span {
    color: ${colors.neutralColorHighPure};
  }
`

export const LabelContainer = styled.div``

ButtonUpload.defaultProps = defaultTheme
IconContainer.defaultProps = defaultTheme
